import { SelectablePill } from '@mobilefirstdev/reactive-form';

export const NO_TAG_VALUE = '-';

export class Tag implements SelectablePill {
  public title: string;
  public value: string;

  constructor(value: string) {
    this.title = value?.toUpperCase();
    this.value = value;
  }

  static noTag(title: string): Tag {
    const t = new Tag(NO_TAG_VALUE);
    t.title = title;
    return t;
  }

  static placeholderTag(title: string): Tag {
    const t = new Tag(null);
    t.title = title;
    return t;
  }

  getSelectionTitle(): string {
    return this.title || this.value;
  }

  getSelectionValue(): any {
    return this.value;
  }

  getSelectionUniqueIdentifier(): any {
    return this.value;
  }
}
